<div class="table-responsive">
  <table class="table table-sm table-striped">

    <thead class="hidden-xs hidden-sm">
      @for (heading of days; track heading) {
        <th>{{heading}}</th>
      }
    </thead>
    <tbody>
      @for (asset of tableData; track asset; let i = $index) {
        <tr>
          <td>{{asset.title}}</td>
          @for (value of asset.values; track value) {
            <td>{{value || '--.-'}}</td>
          }
        </tr>
      }
    </tbody>

  </table>
</div>